<template>
    <div v-if="themeStore.themeIndex === 1">
        <GameHeaderBarOne @back-click="handleBackClick" @show-deposit-popup="showDepositPopup" :notice-text="noticeText"
            :is-favorite="isFavorite" @add-favorite="addFavorite" />
    </div>
    <div v-if="themeStore.themeIndex === 2">
        <GameHeaderBarTwo @back-click="handleBackClick" @show-deposit-popup="showDepositPopup" :notice-text="noticeText"
            :is-favorite="isFavorite" @add-favorite="addFavorite" />
    </div>
    <div v-if="themeStore.themeIndex === 3">
        <GameHeaderBarThree @back-click="handleBackClick" @show-deposit-popup="showDepositPopup"
            :notice-text="noticeText" :is-favorite="isFavorite" @add-favorite="addFavorite" />
    </div>
    <div v-if="themeStore.themeIndex === 4">
        <GameHeaderBarFour @back-click="handleBackClick" @show-deposit-popup="showDepositPopup"
            :notice-text="noticeText" :is-favorite="isFavorite" @add-favorite="addFavorite" />
    </div>

    <van-popup v-model:show="show" position="right" :style="{
        width: '100%',
        height: '100%',
        color: '#fff',
        overflow: 'hidden',
        background: themeStore.themeIndex == 1 ? '#1e130b' : themeStore.themeIndex == 2 ? '#221b24' : '#101423',
    }">
        <van-row :style="{ background: themeStore.themeIndex == 1 ? '#27190D' :themeStore.themeIndex == 2 ? '#312734':'#154084' }">
            <van-col span="2">
                <img v-if="themeStore.themeIndex === 1" width="100%" src="@/assets/common/icon_back.png" alt=""
                    @click="closePopup">
                <img v-if="themeStore.themeIndex === 2" width="100%" src="@/assets/themetwo/back.png" alt=""
                    @click="closePopup">
                <img v-if="themeStore.themeIndex === 3" width="50%" style="padding: 15px;" src="@/assets/common/backIcon.png" alt=""
                    @click="closePopup">
            </van-col>
            <van-col span="20" style="display: flex; justify-content: center; align-items: center; text-align: center; font-size: 15px;
        ">{{ $t('common.deposite') }}</van-col>
        </van-row>

        <div style="padding: 0px 20px;">
            <DepositView :is-component="true" />
        </div>


    </van-popup>

</template>
<script setup lang="ts">
import { useThemeStore } from '@/stores/theme'
import GameHeaderBarOne from '@/themes/themeOne/game/components/gameHeaderBar.vue'
import GameHeaderBarTwo from '@/themes/themeTwo/game/components/gameHeaderBar.vue'
import GameHeaderBarThree from '@/themes/themeThree/game/components/gameHeaderBar.vue'
import GameHeaderBarFour from '@/themes/themeFour/game/components/gameHeaderBar.vue'
import DepositView from '@/view/deposit/depositView.vue'
import { getNewsBarText } from '../supportScript'
import { ref } from 'vue'
const props = defineProps<{
    isFavorite?: boolean
}>()
const themeStore = useThemeStore()
const noticeText = ref(getNewsBarText())
const show = ref(false)
const emits = defineEmits(['backClick', 'addFavorite'])
const handleBackClick = () => {
    emits('backClick')
}

const showDepositPopup = () => {
    show.value = true
    localStorage.setItem('showDepositBackIcon','1')
}

const closePopup = () => {
    show.value = false
    localStorage.setItem('showDepositBackIcon','0')
}

const addFavorite = () => {
    emits('addFavorite')
}
</script>
<style scoped></style>